export const REDUCER_NAME = 'search'




// WEBPACK FOOTER //
// ./src/modules/sales-order/state/search/const.js